export default "__VITE_ASSET__9563a738__"